import PropTypes from "prop-types";
import { memo } from "react";
import "./FacebookLogin.scss";
import { FormattedMessage } from "react-intl";
import { SocialFacebookIcon } from "app/icons/logo";
import { Spinner } from "app/icons/navigation/Spinner";

const FacebookLogin = ({ isDisabled, onClick, isLoading }) => {
	return (
		<button
			type="button"
			className="facebook-login"
			onClick={onClick}
			disabled={isDisabled || isLoading}
			aria-busy={isLoading || undefined}
			data-testid="facebook-login-button"
		>
			{isLoading ? (
				<Spinner size={16} />
			) : (
				<>
					<SocialFacebookIcon className="facebook-login__icon" height={18} width={18} />
					<FormattedMessage id="auth.facebook.button.label" />
				</>
			)}
		</button>
	);
};

FacebookLogin.propTypes = {
	onClick: PropTypes.func,
	isLoading: PropTypes.bool,
	isDisabled: PropTypes.bool,
};

export default memo(FacebookLogin);
